var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 5.926,
    viewBox: "0 0 10 5.926",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "down-arrow",
    d: "M9.719,5.65a.949.949,0,0,1-1.338,0L4.976,2.292,1.618,5.65A.949.949,0,1,1,.281,4.3L4.3.281a.949.949,0,0,1,1.347,0L9.719,4.3a.949.949,0,0,1,0,1.347Z",
    transform: "translate(10 5.926) rotate(180)",
    fill: "#474b4f",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow_icon.00b9739953cc90998e16f444bb78a530.svg";
export { ForwardRef as ReactComponent };